import { Link } from "react-router";
import { JSX } from "react";
import { RouteEnum } from "../../../common/enums/RouteEnum";

export const ShowEstablishmentDetailsHeader = (): JSX.Element => {
    return (
        <div className={"p-show-establishment-details__header"}>
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /
                    Vestiging / Vestigingsgegevens
                </span>
            </div>
            <div className={"p-show-establishment-details__header__title"}>
                <h1>Vestigingsgegevens</h1>
            </div>
        </div>
    );
};
